import { tv } from 'tailwind-variants'

export const chatFinishedTagVariants = tv({
  slots: {
    container: 'flex justify-center mt-mili',
    row: 'flex items-center py-micro px-centi rounded-mili bg-error-xlight gap-x-mili',
    text: 'text-base font-bold text-error-medium',
    icon: 'text-error-medium'
  }
})
